import React from 'react';
import { useTranslation } from 'react-i18next';
import DynamicCrudPage from '../../../components/DynamicCrudPage';
import { useTitles, useCompanies } from '../../../hooks';
import AddIcon from '@mui/icons-material/Add';

const TitlesPage = () => {
  const { t } = useTranslation();

  return (
    <DynamicCrudPage
      entityType="titles"
      hook={useTitles}
      additionalHooks={{
        companies: useCompanies,
      }}
      addButtonTextKey="table.actions.addTitle"
      addButtonIcon={<AddIcon />}
      entityTypeForDataTable="title"
    />
  );
};

export default TitlesPage;
